import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { getOpioid, updateOpioid, deleteOpioid } from "@/lib/admin-substances.functions";
import { opioidInputSchema } from "@/lib/admin-substances.schemas";
import { CompoundForm, OPIOID_FORM } from "@/components/admin/CompoundForm";

export const Route = createFileRoute("/_authenticated/_admin/admin/opioide/$id/edit")({
  component: EditOpioidPage,
});

function EditOpioidPage() {
  const { id } = useParams({ from: "/_authenticated/_admin/admin/opioide/$id/edit" });
  const navigate = useNavigate();
  const fetch = useServerFn(getOpioid);
  const submit = useServerFn(updateOpioid);
  const remove = useServerFn(deleteOpioid);
  const qc = useQueryClient();
  const [initial, setInitial] = useState<any>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetch({ data: { id } }).then(setInitial).catch((e) =>
      toast.error("Laden fehlgeschlagen", { description: e?.message })
    );
  }, [id, fetch]);

  if (!initial) return <p style={{ padding: "2rem", color: "var(--text-muted)" }}>Lade...</p>;

  return (
    <div style={{ padding: "2rem 1.5rem" }}>
      <CompoundForm
        config={{ ...OPIOID_FORM, title: `Opioid bearbeiten: ${initial.substance}` }}
        initial={initial}
        submitting={submitting}
        onCancel={() => navigate({ to: "/admin" })}
        onSubmit={async (values) => {
          const parsed = opioidInputSchema.safeParse(values);
          if (!parsed.success) {
            toast.error("Eingabe ungueltig", { description: parsed.error.issues.map(i => i.message).join("; ") });
            return;
          }
          setSubmitting(true);
          try {
            await submit({ data: { id, data: parsed.data } as any });
            toast.success("Aktualisiert");
            qc.invalidateQueries({ queryKey: ["admin-substances"] });
            qc.invalidateQueries({ queryKey: ["public-opioids"] });
            navigate({ to: "/admin" });
          } catch (e: any) {
            toast.error("Speichern fehlgeschlagen", { description: e?.message ?? String(e) });
          } finally {
            setSubmitting(false);
          }
        }}
      />
      <div style={{ maxWidth: 880, margin: "1.5rem auto 0", textAlign: "right" }}>
        <button
          onClick={async () => {
            if (!confirm(`"${initial.substance}" wirklich loeschen?`)) return;
            try {
              await remove({ data: { id } });
              toast.success("Geloescht");
              qc.invalidateQueries({ queryKey: ["admin-substances"] });
              qc.invalidateQueries({ queryKey: ["public-opioids"] });
              navigate({ to: "/admin" });
            } catch (e: any) {
              toast.error("Loeschen fehlgeschlagen", { description: e?.message ?? String(e) });
            }
          }}
          style={{ background: "transparent", color: "#ef4444", border: "1px solid #ef4444", borderRadius: 6, padding: "0.4rem 0.9rem", cursor: "pointer" }}
        >
          Loeschen
        </button>
      </div>
    </div>
  );
}
